<div class="container-fluid py-3 daily-expense-view">

  <div class="card shadow-sm border-0">

    <!-- Header -->
    <div class="card-header bg-white d-flex flex-wrap align-items-center justify-content-between gap-2">
      <h5 class="mb-0">Daily Expense Report</h5>
    </div>

    <div class="card-body">

      <!-- Date and expense filters -->
      <div class="row g-2 align-items-end">

        <div class="col-12 col-sm-6 col-lg-3">
          <label for="startDate" class="form-label">
            From Date <span class="text-danger">*</span>
          </label>

          <input
            id="startDate"
            class="form-control"
            type="date"
            [(ngModel)]="startDate"
            [ngModelOptions]="{ standalone: true }"
            [max]="today"
            (ngModelChange)="onDateChange()">

          <div
            class="text-danger small mt-1"
            *ngIf="validationMessage && !startDate">
            Please select From Date.
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-3">
          <label for="endDate" class="form-label">
            To Date <span class="text-danger">*</span>
          </label>

          <input
            id="endDate"
            class="form-control"
            type="date"
            [(ngModel)]="endDate"
            [ngModelOptions]="{ standalone: true }"
            [min]="startDate || null"
            [max]="today"
            (ngModelChange)="onDateChange()">

          <div
            class="text-danger small mt-1"
            *ngIf="validationMessage && !endDate">
            Please select To Date.
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-3">
          <label for="expenseSeq" class="form-label">
            Expense Name
          </label>

          <select
            id="expenseSeq"
            class="form-select"
            [(ngModel)]="selectedExpenseSeq"
            [ngModelOptions]="{ standalone: true }">

            <option [ngValue]="''">All Expenses</option>

            <option
              *ngFor="let item of expenseMasters"
              [ngValue]="item.expenseSeq">
              {{ item.name }}
            </option>
          </select>
        </div>

        <div class="col-12 col-sm-6 col-lg-3 d-flex gap-2">
          <button
            class="btn btn-primary flex-grow-1"
            type="button"
            (click)="searchByDate()"
            [disabled]="loading">

            <span
              *ngIf="loading"
              class="spinner-border spinner-border-sm me-1">
            </span>

            Search
          </button>

          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="resetFilters()"
            [disabled]="loading">

            Reset
          </button>
        </div>

      </div>

      <!-- Date validation -->
      <div
        *ngIf="validationMessage"
        class="alert alert-danger mt-3 mb-0">

        <i class="bi bi-exclamation-circle me-1"></i>
        {{ validationMessage }}
      </div>

      <!-- Search, export and summary -->
      <div class="row g-2 align-items-end mt-3 mb-3">

        <div class="col-12 col-md-4">
          <label for="searchText" class="form-label">
            Search Results
          </label>

          <input
            id="searchText"
            class="form-control"
            type="search"
            [(ngModel)]="searchText"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Search name or description">
        </div>

        <div class="col-12 col-md-3">
          <button
            type="button"
            class="btn btn-success w-100"
            (click)="exportExcel()"
            [disabled]="filteredExpenses.length === 0">

            <i class="bi bi-file-earmark-excel me-1"></i>
            Export Excel
          </button>
        </div>

        <div class="col-6 col-md-2">
          <div class="summary-card">
            <div class="text-muted small">Filtered Entries</div>
            <div class="summary-value">
              {{ filteredExpenses.length }}
            </div>
          </div>
        </div>

        <div class="col-6 col-md-3">
          <div class="summary-card">
            <div class="text-muted small">Total Expense Amount</div>
            <div class="summary-value">
              {{ totalAmount | currency:'INR':'symbol':'1.2-2':'en-IN' }}
            </div>
          </div>
        </div>

      </div>

      <!-- Expense table -->
      <div class="table-style table-responsive table-bordered">
        <table class="table table-head-fixed text-nowrap text-center">

          <thead class="table-light">
            <tr>
              <th>S.No</th>
              <th>Expense Date</th>
              <th>Expense Name</th>
              <th>Description</th>
              <th>Amount</th>
              <th>Bill</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>

            <tr *ngFor="let item of filteredExpenses; let i = index">

              <td>{{ i + 1 }}</td>

              <td>
                {{ formatDisplayDate(item.expenseDate) }}
              </td>

              <td>{{ item.expenseName }}</td>

              <td class="description-cell">
                {{ item.description }}
              </td>

              <td>
                {{ item.amount | currency:'INR':'symbol':'1.2-2':'en-IN' }}
              </td>

              <td>
                <span
                  *ngIf="item.hasBill"
                  class="badge text-bg-success">
                  Attached
                </span>

                <span
                  *ngIf="!item.hasBill"
                  class="badge text-bg-secondary">
                  No bill
                </span>
              </td>

              <td>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary me-1"
                  title="Edit"
                  (click)="editExpense(item)">

                  <i class="bi bi-pencil"></i>
                  <span class="d-none d-lg-inline"> Edit</span>
                </button>

                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  title="Delete"
                  (click)="deleteExpense(item)"
                  [disabled]="loading">

                  <i class="bi bi-trash"></i>
                  <span class="d-none d-lg-inline"> Delete</span>
                </button>
              </td>

            </tr>

            <tr *ngIf="loading">
              <td colspan="7" class="text-center py-4">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Loading daily expenses...
              </td>
            </tr>

            <tr *ngIf="!loading && filteredExpenses.length === 0">
              <td colspan="7" class="text-center text-danger py-4">
                No daily expenses found for the selected filters.
              </td>
            </tr>

          </tbody>

        </table>
      </div>

    </div>
  </div>
</div>